import { useSharedContext } from "./shared-context";
import { fhirSections } from "../shared-components/fhir-sections/sections";
import { useMemo } from "react";

export const useFhirSections = () => {
  const { sharedState } = useSharedContext();
  const isShowDummySections = sharedState.isMetriportUser;
  const isAmazonUser = sharedState.isAmazonUser;

  const filteredFhirSections = useMemo(() => {
    const dummySections = ["caregaps"];
    const amazonOnlySections = ["suspects"];

    return fhirSections.filter(section => {
      // Filter out dummy sections for non-Metriport users
      if (dummySections.includes(section.key) && !isShowDummySections) {
        return false;
      }

      // Filter out Amazon-only sections for non-Amazon users
      if (amazonOnlySections.includes(section.key) && !isAmazonUser) {
        return false;
      }

      return true;
    });
  }, [fhirSections, isShowDummySections, isAmazonUser]);

  return { filteredFhirSections };
};
